export const populateFields = async (firebaseData, fields = []) => {
  await Promise.map(fields, async (field) => {
    const poRef = await firebaseData[field].get()
    firebaseData[field] = poRef.data()
  })
  return firebaseData
}

export const parseDocument = (firebaseDocument) => {
  return { id: firebaseDocument.id, created: 0, ...firebaseDocument.data() }
}

export const guid = () => {
  function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export const eventag = (opt, that) => {
  (that.$ga || (that.$vue || that._vm).__proto__.$ga).event({
    ...opt
  })
}